import { Layout, Dashboard, Add } from '@/views/trade';

export default {
    path: '/trade',
    component: Layout,
    children: [
        { path: 'dashboard', component: Dashboard },
        { path: 'add', component: Add },
    ]
};
